import CheckSuccessfullyIcon from 'components/shared/icons/check-successfully'
import CloseIcon from 'components/shared/icons/close'
import Modal from 'components/shared/modal'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

const RequestSendSuccessfully = ({ toggle, place, city, isBuildingRequest = false }) => {
  const history = useHistory()
  return (
    <Modal contentClassName="" onClose={toggle} headerClose={false}>
      <div className="flex flex-row-reverse">
        <span onClick={toggle} className="py-3 px-4 cursor-pointer">
          <CloseIcon/>
        </span>
      </div>
      <div className="items-center justify-center flex">
        <CheckSuccessfullyIcon/>
      </div>
      <div className="py-2 px-12 text-2xl text-center lato-reg">We have received your request</div>
      <p className="text-base px-12 text-center lato-reg">
        A commercial property agent will get back to you as soon as possible to advise you on your office search
      </p>
      {<div className="px-12 pb-10 pt-6">
        <button
          onClick={() => {
            if (!isBuildingRequest) {
              return history.push(`/${place ?? city}/traditional-office`)
            }
            return toggle()
          }}
          className="text-sm rounded bg-primary-orange w-full lato-bold h-10 text-white"
        >
          {isBuildingRequest ? 'Done' : 'Browse more spaces'}
        </button>
      </div>}
    </Modal>
  )
}

RequestSendSuccessfully.propTypes = {
  toggle: PropTypes.func,
  place: PropTypes.string,
  city: PropTypes.string,
  isBuildingRequest: PropTypes.bool
}

const mapStateToProps = ({ ...state }) => {
  return {
    state,
    place: state.space.spaceInfo.place,
  }
}
export default connect(mapStateToProps)(RequestSendSuccessfully)
